import { routesConfig } from 'config/routes/routes.config';
import type { MatchHandle } from 'types/matchHandle';

export const handle: MatchHandle = {
	withoutAuthLinkRedirect: routesConfig.root.authorization.absolutePath,
};
